$(document).ready(function(){
    $('.bs_variant_sel').click(function(){
      if ($(this).hasClass('notSelectable')){
        
      }
      else{
          $('.bs_variant_sel').removeClass('active');
          $(this).addClass('active');
          var currentId  = $(this).attr('data-id');
          console.log(currentId);
          $('.bs_price').hide();
          $('.bs_price[data-id="'+currentId+'"]').show(); 
      }
    });

    $('.bs_purchase_mode_btn').click(function(){
      $('.bs_purchase_mode_btn').removeClass('active');
      $(this).addClass('active');
      var mode = $(this).attr('data');
      console.log(mode, 'moe');
      if (mode == 'sub'){
        $('.priceToCHange[data="otpPrice"]').addClass('hidded');
        $('.priceToCHange[data="subPrice"]').removeClass('hidded');
      }
      else{
        $('.priceToCHange[data="subPrice"]').addClass('hidded');
        $('.priceToCHange[data="otpPrice"]').removeClass('hidded');
      }
    });
});